module.exports = __webpack_public_path__ + "img/hr-heated-corner-down-left-4.cb67f99b.png";